module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAAA/klEQVRYhe2YzQ2CQBBGP413W7AEO1Ar0dt3tQQ70Ouc1A4swRIsATvQCjCbsBvioOMPko2Zd4EMC7zMLANLryxL5EQ/KxsXeoHshAZxh+QCwAbAUI36LXsASxG5JCGSUwDbjkUi82obEpJKtlDDuiVKpZKNarcPKdx1oDMGsL4PDtQwoBCRo4q2DMnGC/pjb+FCFi5k4UIWTY3xLUh+0kTDm6BQ0TaEAExUxOb4SMjnkIULWbiQxf81RgAzFbEp7j6bnwpNSa5UtH2eCp1qHXfyYff9hnM8N86hsEC8dixRJ1Uk/Y4hOaoONKbyR4TV6k5EDkooF7wPWeQlBOAGZAMsulE624QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_brand.png
// module id = iKRe
// module chunks = 4